import React from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import classNames from 'classnames';
import Vendor from '../records/vendor';
import AuthHeaderMenuVendorNav from './AuthHeaderMenuVendorNav';
import AuthHeaderVouchers from './AuthHeaderVouchers';
import ProfilePic from './User/ProfilePic';
import styled from 'styled-components';

const RedeemButton = styled.button`
  border: 0;
  background: transparent;
  color: #fff;
  padding: 0;
`;

class AuthHeader extends React.Component {
  state = {
    menu: false,
    vouchers: false
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.customer.get('toggle').get('menu')) {
      this.setState({ menu: true });
    }
  }

  handleClickOutside() {
    this.setState({ menu: false });

    if (this.props.customer.get('toggle').get('menu')) {
      this.props._customer.toggleUserMenu();
    }
  }

  toggleMenu = () => {
    this.setState({ menu: !this.state.menu });
    this.props._customer.toggleUserMenu();
  }

  isValidAuth = vendor => {
    return vendor && vendor.id !== null;
  }

  toggleVouchers = () => {
    this.setState({ vouchers: !this.state.vouchers });
  }

  render() {
    let vendor;
    const { customer, entities } = this.props

    vendor = this.props.vendor;
    if (!vendor) vendor = new Vendor();

    return <div>
      <div className="d-flex flex-wrap">
        {customer.get('loading').get('vendors') && <RedeemButton>
          <i className="text-orange fa fa-tag" aria-hidden="true" />
          {' '}
          Checking for vouchers...
          <span style={{margin: '0 .5rem'}}>{' '}</span>
        </RedeemButton>}
      {entities.get('vouchers').size > 0 &&
        <RedeemButton onClick={this.toggleVouchers}>
          <i className="text-orange fa fa-tag" aria-hidden="true" />{' '}
          Redeem Vouchers
        </RedeemButton>
      }
      {entities.get('vouchers').size > 0 && <span style={{margin: '0 .5rem'}}>{' '}</span>}
      <span onClick={this.toggleMenu}>
        <img
          className={classNames('mr-1', {'hidden-sm-down': this.isValidAuth(vendor)})}
          src={vendor.profilePicUrl(
            "w_400,h_400,c_crop,g_face,r_max,b_rgb:4c1a2c/w_30,h_30/d_profile.png",
            'users'
          )}
          alt="profile" />
        {" "}
        {this.isValidAuth(vendor) && <span className="header-menu-toggle-name">{vendor.get("name")}</span>}
        {" "}
        <i className={classNames('fa fa-angle-down header-menu-toggle-indicator', {'header-menu-expanded': this.state.menu})} />
      </span>
      </div>

      {this.state.menu &&
       customer.get('toggle').get('menu') &&
        <div className="header-menu">
          <ProfilePic
            {...this.props}
            vendor={vendor}
            view="header" />

          {this.isValidAuth(vendor) && <p style={{ marginTop: '20px' }}>
            {customer.get('account').get('name')}
          </p>}

          <hr className="tomato" />

          <AuthHeaderMenuVendorNav
            {...this.props}
            vendor={vendor}
            isValidAuth={this.isValidAuth}
            toggleMenu={this.toggleMenu} />
        </div>}

        <AuthHeaderVouchers 
          {...this.props}
          show={this.state.vouchers}
          toggle={this.toggleVouchers} />
    </div>;
  }
}

AuthHeader.propTypes = {
  customer: PropTypes.object.isRequired,
  vendor: PropTypes.object
}

export default onClickOutside(AuthHeader);



// WEBPACK FOOTER //
// ./src/components/AuthHeader.js